import React from 'react';
import moment from 'moment';
import {connect} from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import {playerActions} from '../../actions';
import { prettyDate } from '../../_helpers';
import GameRoster from './GameRoster';

class Game extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            reserveModal: false,
            cancelModal: false,
            isGoalie: false,
        }
    }

    handleOptionChange = (changeEvent) => {
        this.setState({
            isGoalie: changeEvent.target.value === 'true'
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { isGoalie } = this.state;
        this.props.addPlayer(this.props.game, isGoalie);
        this.toggleReserve();
    }

    handleCancel = (e) => {
        e.preventDefault();
        this.props.removePlayer(this.props.game);
        this.toggleCancel();
    }

    toggleReserve = () => {
        this.setState({
            reserveModal: !this.state.reserveModal
        });
    }

    toggleCancel = () => {
        this.setState({
            cancelModal: !this.state.cancelModal
        });
    }

    isCancelHidden = () => {
        let gameStartTime = moment(this.props.game.gameStartTime);
        let expireTime = gameStartTime.subtract(6, 'hours')
        if(expireTime.isBefore()){
            return true;
        }
        return !this.props.game.isPlayer;
    }

    render(){
        const { isGoalie } = this.state;
        const playerSpotsLeft = this.props.game.maxPlayers - this.props.game.playerCount;
        const goalieSpotsLeft = this.props.game.maxGoalies - this.props.game.goalieCount;
        const totalSpotsLeft = playerSpotsLeft + goalieSpotsLeft;
        return(
            <div className="col-md-6 col-xs-12">
                <div className="card mt3 mb3">
                    <div className="card-body">
                        <h4 className="card-title">{moment(this.props.game.gameStartTime).format('dddd, MMMM DD, YYYY')}</h4>
                        <div className="card-text"><strong>Time:</strong> {moment(this.props.game.gameStartTime).format('h:mm a')} - {moment(this.props.game.gameEndTime).format('h:mm a')}</div>
                        <div className="card-text"><strong>Arena:</strong> {this.props.game.arena}</div>
                        <div className="card-text"><strong>Credit Cost:</strong> {this.props.game.playerCost}</div>
                        <br />
                        <div className="card-text"><strong>Player Spots Remaining:</strong> {playerSpotsLeft}/{this.props.game.maxPlayers}</div>
                        <div className="card-text"><strong>Goalie Spots Remaining:</strong> {goalieSpotsLeft}/{this.props.game.maxGoalies}</div>
                        <Button color="primary" className="mt3" onClick={this.toggleReserve} disabled={this.props.game.isPlayer || totalSpotsLeft === 0 || false}>{this.props.game.isPlayer ? 'Spot Reserved!' : (totalSpotsLeft === 0 ? 'Game Full' : 'Reserve Spot')}</Button>
                        <GameRoster game={this.props.game} />
                        <div>
                            <Button color="link" onClick={this.toggleCancel} style={{fontSize: '10px', padding: '0'}} hidden={this.isCancelHidden()}>Cancel Spot</Button>
                        </div>
                    </div>
                </div>
                <Modal isOpen={this.state.reserveModal} toggle={this.toggleReserve} className={this.props.className}>
                    <ModalHeader toggle={this.toggleReserve}>{prettyDate(this.props.game.gameStartTime)}</ModalHeader>
                    <ModalBody>
                        <p>By clicking "Reserve" you agree to use {this.props.game.playerCost} credits and reserve a spot for the game on {prettyDate(this.props.game.gameStartTime)}. You can cancel you spot up to 6 hours before a game starts. If you have any issues email admin@tbayshinny.com</p>
                        <div>
                            <p><strong>Reserve spot as a:</strong></p>
                            <div className="form-check form-check-inline">
                                <input 
                                    className="form-check-input" 
                                    type="radio" 
                                    name="isGoalie" 
                                    id="isPlayerRadio" 
                                    value="false"
                                    checked={!isGoalie} 
                                    onChange={this.handleOptionChange} />
                                <label className="form-check-label" htmlFor="isPlayerRadio">Player</label>
                            </div>
                            <div className="form-check form-check-inline">
                                <input 
                                    className="form-check-input" 
                                    type="radio" 
                                    name="isGoalie" 
                                    id="isGoalieRadio" 
                                    value="true"
                                    checked={isGoalie} 
                                    onChange={this.handleOptionChange} />
                                <label className="form-check-label" htmlFor="isGoalieRadio">Goalie ({this.props.game.goalieCost} credits)</label>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.handleSubmit}>Reserve</Button>{' '}
                        <Button color="secondary" onClick={this.toggleReserve}>Cancel</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.cancelModal} toggle={this.toggleCancel} className={this.props.className}>
                    <ModalHeader toggle={this.toggleCancel}>{prettyDate(this.props.game.gameStartTime)}</ModalHeader>
                    <ModalBody>
                        <p>Are you sure you want to give up your spot in the game on {prettyDate(this.props.game.gameStartTime)}. After you click "Confirm" you will lose your spot.</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="danger" onClick={this.handleCancel}>Confirm</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

export default connect(null, playerActions)(Game);


// WEBPACK FOOTER //
// ./src/components/Games/Game.js